<kilden3-header />
<div class="content-container">
  <kilden3-left class="left-container"> </kilden3-left>
  <kilden3-map class="map-container"> </kilden3-map>
</div>
